import React from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import Newsletter from "../Newsletter/Newsletter";

const BannerView = observer((props) => {
  const { t } = useTranslation("common");

  return (
    <Newsletter
      title={t("contact.newsletter_title")}
      description={t("contact.newsletter_description")}
    />
  );
});
export default BannerView;
